import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { Container } from "@mui/system";

import { green } from "@mui/material/colors";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { usePasswordRequestMutation } from "../../../services/apiSlice";

const defaultValues = {
  email: "",
};
//
const ForgotpasswordRequest = () => {
  const navigate = useNavigate();
  const [passwordRequest, { data, error, isError, isSuccess }] =
    usePasswordRequestMutation();
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,

    register,

    formState: { errors },
  } = methods;
  useEffect(() => {
    console.log({ data });
    if (isSuccess && data && data?.success === true) {
      Swal.fire("Awesome!", ` ${data.message}`, "success").then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          navigate("/login");
        }
      });
    } else if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else if (data?.success === false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data?.message,
      });
    }
  }, [data, isError]);

  const onSubmit = async (data) => {
    console.log("pass req", data);
    await passwordRequest(data);
  };
  return (
    <>
      <Container>
        <Box maxWidth={"md"} className="min-h-screen" sx={{ mt: 10 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Paper
              style={{
                display: "flex",
                flexDirection: "column",
                gridRowGap: "20px",
                padding: "20px",
                // margin: "30px 300px",
              }}
              sx={{
                width: "md",
              }}
            >
              <Typography
                variant="h1"
                component="h2"
                className="md:text-3xl text-base uppercase font-extrabold text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Forget password Request
              </Typography>

              <TextField
                id="outlined-basic"
                label="E-mail"
                variant="outlined"
                fullWidth
                name="email"
                size={"small"}
                {...register("email", {
                  required: "Email is Required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                error={Boolean(errors.email)}
                helperText={
                  errors.email && errors.email.type === "required"
                    ? errors.email.message
                    : errors.email &&
                      errors.email.type === "pattern" &&
                      errors.email.message
                }
              />

              <div className="clearfix"></div>
              <Button
                variant="contained"
                type="submit"
                className="hover:bg-green-300"
                sx={{
                  color: "white",
                  background: green[600],
                  // width: "40%",
                  // mx: 30,
                  textAlign: "center",
                  placeItems: "center",
                }}
              >
                Send Request
              </Button>

              <Typography
                variant="p"
                component="p"
                className="text-base  font-normal text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Remebered your password?{" "}
                <Link to={"/login"}>
                  {" "}
                  <Typography
                    variant="span"
                    component="span"
                    className="text-blue-500 text-lg  mx-2 font-normal text-center py-2 md:py-4 "
                    sx={{ textAlign: "center" }}
                  >
                    Login
                  </Typography>{" "}
                </Link>
              </Typography>
            </Paper>
          </form>
        </Box>
      </Container>
    </>
  );
};

export default ForgotpasswordRequest;
